var _circle, _circle2, _circle3, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgCheckinFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 151,
    viewBox: "0 0 153 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 76.5,
    cy: 75.5,
    r: 70,
    stroke: "#FFD4D6",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.34,
    cx: 76.5,
    cy: 75.5,
    r: 75,
    stroke: "#FFD4D6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.5,
    cy: 75.5,
    r: 63.5,
    stroke: "#FFD4D6",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 75C16 41.8629 42.8629 15 76 15C109.137 15 136 41.8629 136 75C136 108.137 109.137 135 76 135C42.8629 135 16 108.137 16 75Z",
    fill: "#F8696E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5 115C76.5 115 46.5 82.5 46.5 65C46.5 48.4375 59.9375 35 76.5 35C93.0625 35 106.5 48.4375 106.5 65C106.5 82.5 76.5 115 76.5 115ZM91.6562 55L86.5 49.8438L83.8438 52.5L76.5 59.8438L69.1562 52.5L66.5 49.8438L61.1875 55L63.8438 57.6562L71.1875 65L63.8438 72.3438L61.1875 75L66.5 80.3125L69.1562 77.6562L76.5 70.3125L83.8438 77.6562L86.5 80.3125L91.6562 75L89 72.3438L81.6562 65L89 57.6562L91.6562 55Z",
    fill: "url(#paint0_linear_16138_324701)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16138_324701",
    x1: 76.5,
    y1: 65,
    x2: 76.5,
    y2: 85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgCheckinFailed);
export default __webpack_public_path__ + "static/media/img_checkin_failed.e5248f86494d64a19619b61672ca712f.svg";
export { ForwardRef as ReactComponent };